import axios from '.'

export default {
  getRouteDetail: params =>
    axios.get('/tms/tempOrder/router/detail/' + params.id, {
      params: {
        ...params
      }
    }),
  getVehicleList: params =>
    axios.post('/motorcade/vehicle/listTrucksPage', {
      ...params
    }),
  updateRouteModifyFreight: params =>
    axios.post('/tms/tempOrder/router/updateRouteModifyFreight', {
      ...params
    }),
  queryDriverByCompanyId: params =>
    axios.post('/company/api/driver/queryDriverByCompanyId', {
      ...params
    }),
  createOrderBatch: params =>
    axios.post('/tms/tempOrder/router/createOrderBatch', {
      ...params
    }),
  listSettlementObject: params =>
    axios.post('/company/api/user/listSettlementObject', {
      ...params
    }),
  queryUserByMobile: params =>
    axios.get('/company/api/user/queryUserByMobile/' + params.mobile, {
      params: {
        ...params
      }
    }),
  roulButton: params =>
    axios.get('/tms/tempOrder/router/roulButton/' + params.id, {
      params: {
        ...params
      }
    }),
}
// export function loadNetworkPerformanceStatus (param) {
//   return axios.get('/tms/tempOrder/router/detail/'+param.id)
// }

// export function loadServerStatus () {
//   return axios.get('/loadServerData')
// }

// export function loadPvStatus () {
//   return axios.get('/loadPvData')
// }

// export function loadVisitStatus () {
//   return axios.get('/loadVisitData')
// }